export default "__VITE_ASSET__Da0YH_i4__"